import { IDataProvider } from '../Data/IDataProvider';
import { ILogEntry } from '../Entity/ILogEntry';
import { AddGoalDatapointFromLogEntryAsync } from './DatapointRepository';
import { AddLogEntryAsync } from './LogRepository';

export async function SaveLogEntryAsync(
	inputValues: string[],
	dataProvider: IDataProvider,
	/** 
	 * Prevent unnecessary function calls to speed up multiple save requests
	 */
	rapidEntry?: boolean,
	OnError?: Function,
	OnFinish?: Function
) {
	if (!inputValues) {
		throw new Error('Missing input values!');
	}

	if (OnError) {
		OnError();
	}

	const entryText = inputValues[0].replace("'", '');

	let goalDatapointId:
		| number
		| undefined = await AddGoalDatapointFromLogEntryAsync(
		entryText,
		dataProvider,
	);

	const newLogEntry = GetNewLogEntryForInsertion(
		entryText,
		inputValues,
		goalDatapointId
	);

	await AddLogEntryAsync(newLogEntry, dataProvider);

	if (rapidEntry === undefined || rapidEntry === false) {
		if (OnFinish) {
			OnFinish();
		}
	}
}

function GetNewLogEntryForInsertion(
	entryText: string,
	inputValues: string[],
	goaldatapointid?: number
): Partial<ILogEntry> {
	return {
		entry: entryText,
		kips: parseInt(inputValues[1]),
		goaldatapointid,
		significance: entryText.indexOf(' ')
	};
}

export function GetEntryPrefix(
    entrySignificanceIndex: number,
    entrySymbol: string
) {
    return Array(entrySignificanceIndex + 3).join(entrySymbol);
}
